var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReferendaDeciding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11035_47171)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 8,
    fill: "url(#paint0_linear_11035_47171)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.375 15.5C14.375 13.7741 15.7741 12.375 17.5 12.375H24.6283C25.5897 12.375 26.5118 12.7569 27.1916 13.4367L29.5633 15.8084C30.2431 16.4882 30.625 17.4103 30.625 18.3717V28.5C30.625 30.2259 29.2259 31.625 27.5 31.625H25C24.6548 31.625 24.375 31.3452 24.375 31C24.375 30.6548 24.6548 30.375 25 30.375H27.5C28.5355 30.375 29.375 29.5355 29.375 28.5V18.6251H26.5C25.3264 18.6251 24.375 17.6737 24.375 16.5001V13.625H17.5C16.4645 13.625 15.625 14.4645 15.625 15.5V19C15.625 19.3452 15.3452 19.625 15 19.625C14.6548 19.625 14.375 19.3452 14.375 19V15.5ZM28.6794 16.6923C28.8791 16.892 29.0395 17.1236 29.1558 17.3751H26.5C26.0168 17.3751 25.625 16.9833 25.625 16.5001V13.8442C25.8765 13.9605 26.108 14.121 26.3077 14.3206L28.6794 16.6923ZM15.8182 21.375C14.4688 21.375 13.375 22.4688 13.375 23.8182V27.1818C13.375 28.5312 14.4688 29.625 15.8182 29.625H15.875V30.4847C15.8696 30.9242 16.1209 31.3269 16.5187 31.5149C16.9186 31.7039 17.3921 31.6409 17.7286 31.3539L17.7313 31.3515L19.7324 29.625H21.1818C22.5312 29.625 23.625 28.5312 23.625 27.1818V23.8182C23.625 22.4688 22.5312 21.375 21.1818 21.375H15.8182ZM14.625 23.8182C14.625 23.1592 15.1592 22.625 15.8182 22.625H21.1818C21.8408 22.625 22.375 23.1592 22.375 23.8182V27.1818C22.375 27.8408 21.8408 28.375 21.1818 28.375H19.5C19.3501 28.375 19.2052 28.4289 19.0917 28.5268L17.125 30.2237V29C17.125 28.6548 16.8452 28.375 16.5 28.375H15.8182C15.1592 28.375 14.625 27.8408 14.625 27.1818V23.8182Z",
    fill: "#1B202C",
    fillOpacity: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11035_47171",
    x1: 0,
    y1: 0,
    x2: 44,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B202C",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B202C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11035_47171"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferendaDeciding);
export default __webpack_public_path__ + "static/media/referenda-deciding.4b60e2c85b4d9ad173dd734c405345c5.svg";
export { ForwardRef as ReactComponent };